import { useState } from 'react';
import { useLazyGetBanksQuery } from '../../services/bankApi';
export function useGetFinancialInstitutions() {
    const [trigger] = useLazyGetBanksQuery();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [financialInstitutions, setFinancialInstitutions] = useState([]);
    async function getFinancialInstitutions() {
        setLoading(true);
        setError(false);
        try {
            const { data } = await trigger(undefined, false);
            if (!data?.result) {
                setError(true);
            }
            else {
                setFinancialInstitutions(data.result);
                setError(false);
            }
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        financialInstitutions,
        setFinancialInstitutions,
        getFinancialInstitutions,
    };
}
